<template>
  <div class="container px-20 py-32 border-b border-light-gray">
    <div class="mb-32">
      <h2 class="mb-24 font-bold text-22">Accepting payments online through</h2>
      <div
        class="grid grid-cols-3 gap-12 xl:grid-cols-8 lg:grid-cols-6 md:grid-cols-4"
      >
        <div
          v-for="item in onlinePayments"
          :key="item.name"
          class="flex justify-center"
        >
          <img
            :src="'/assets/images/footer-payment-logos/' + item.img + '.png'"
            :alt="item.name"
            :title="item.name"
          />
        </div>
      </div>
    </div>
    <div>
      <h2 class="mb-24 font-bold text-22">
        Accepting installment payments online through
      </h2>
      <div
        class="grid grid-cols-3 gap-12 xl:grid-cols-8 lg:grid-cols-6 md:grid-cols-4"
      >
        <div
          v-for="item in installmentPayments"
          :key="item.name"
          class="flex justify-center"
        >
          <img
            :src="'/assets/images/footer-payment-logos/' + item.img + '.png'"
            :alt="item.name"
            :title="item.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheFooterPaymentMethods",
  data() {
    return {
      onlinePayments: [
        { name: "Visa", img: "visa" },
        { name: "Mastercard", img: "mastercard" },
        { name: "JCB", img: "jcb" },
        { name: "Paymaya", img: "paymaya" },
        { name: "GCash", img: "gcash" },
        { name: "RCBC Bankard", img: "rcbc" },
        { name: "UnionBank", img: "unionbank" },
        { name: "BDO", img: "bdo" },
        { name: "PNB", img: "pnb" },
        { name: "BancNet", img: "bancnet" },
        { name: "Asia United Bank", img: "aub" },
        { name: "BPI Direct Banko", img: "bpi-banko" },
        { name: "CTBC Bank", img: "ctbc" },
        { name: "Citystate Savings Bank", img: "citystate" },
        { name: "Enterprise Bank", img: "enterprise" },
        { name: "Equicom Savings Bank", img: "equicom" },
        { name: "MASS-SPECC", img: "mass-specc" },
        { name: "PBCOM", img: "pbcom" },
        { name: "Pacific Ace Savings Bank", img: "pacific-ace" },
        { name: "Phil Postal Savings Bank", img: "postbank" },
        { name: "Philippine Veterans Bank", img: "veterans" },
        { name: "Philtrust Bank", img: "phil-trust" },
        { name: "Sterling Bank of Asia", img: "sterling" },
        { name: "Sun Savings Bank", img: "sun-savings" },
        { name: "Tiaong Rural Bank", img: "trbi" },
        { name: "DBP", img: "dbp" },
        { name: "Entrepreneur Bank", img: "entrepreneur" },
        { name: "BPI Express Online/Mobile", img: "bpi" },
      ],
      installmentPayments: [
        { name: "BPI Real 0%", img: "bpi-real" },
        { name: "BPI", img: "bpi" },
        { name: "HSBC", img: "hsbc" },
        { name: "UnionBank-New", img: "unionbank" },
      ],
    };
  },
};
</script>

<style scoped></style>
